<template>
  <div class="App-privacyPolicy bg-white">
    <div class="inner text-center">
      <h1 class="h1 title">{{$t('policy.title')}}</h1>
      <div class="content text-left">
        <div class="lead mb-50">{{$t('policy.lead')}}</div>
        <div class="title-mini">{{$t('policy.title1')}}</div>
        <div class="text">{{$t('policy.text1')}}</div>
        <div class="title-mini">{{$t('policy.title2')}}</div>
        <div class="text">{{$t('policy.text2')}}</div>
        <div class="title-mini">{{$t('policy.title3')}}</div>
        <div class="text">{{$t('policy.text3')}}</div>
        <div class="title-mini">{{$t('policy.title4')}}</div>
        <div class="text">{{$t('policy.text4')}}</div>
        <div class="title-mini">{{$t('policy.title5')}}</div>
        <div class="text">{{$t('policy.text5')}}</div>
        <div class="title-mini">{{$t('policy.title6')}}</div>
        <div class="text">{{$t('policy.text6')}}</div>
        <div class="title-mini">{{$t('policy.title7')}}</div>
        <div class="text">{{$t('policy.text7')}}</div>
        <div class="title-mini">{{$t('policy.title8')}}</div>
        <div class="text" v-html="$t('policy.text8')"></div>
        <div class="title-mini">{{$t('policy.title9')}}</div>
        <div class="text">{{$t('policy.text9')}}</div>
        <div class="text date">{{$t('policy.date')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { META_PRIVACYPOLICY } from '../../mixins/metadata.js'

  export default {
    mixins: [META_PRIVACYPOLICY],
    name: 'PrivacyPolicyPage',
  }
</script>
<style scoped>
.text{
  white-space: pre-wrap;
}
</style>
